import React from 'react';
import { useSelector } from 'react-redux';
import Skeleton from 'react-loading-skeleton';

const HeaderInfo = () => {
    const { loading, data } = useSelector((state) => state.settings);

    return (
        <div className="header__info">
            { loading ? <Skeleton /> : <p>Masz pytania? {data && data.phone}</p>}
            { loading ? <Skeleton /> : <p>Poniedziałek - Piątek {data && data.infolineHours}</p>}
        </div>
    );
};

export default HeaderInfo;
